import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify'
import colors from 'vuetify/lib/util/colors';
import { TokenService } from './services/storage.service';
import ApiService from './services/api.service';
import VeeValidate from 'vee-validate';
Vue.config.productionTip = true;

ApiService.init("https://ayoolacore.herokuapp.com/");

//ApiService.init("https://localhost:44324/");

if (TokenService.getToken()) {
    ApiService.setHeader()

}
Vue.use(VeeValidate);


new Vue({
    vuetify,
    colors,

    
   

    render: h => h(App)
}).$mount('#app');